import styled from '@mui/system/styled';

export const PreviewContainer = styled('div')({
  width: '100%',
  marginTop: 30,
});
